import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

/*
  Allows custom tags and attributes (see SANITIZE_CONFIG) in [innerHtml].
*/
const SANITIZE_CONFIG = {
  ADD_ATTR: ['routerlink', 'openPdf', 'target'],
  FORBID_TAGS: ['style'],
};

@Pipe({ name: 'safeHtml' })
export class SafeHtml implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(input: unknown): any {
    if (typeof input === 'string') {
      return this.sanitizer.bypassSecurityTrustHtml(DOMPurify.sanitize(input, SANITIZE_CONFIG));
    }

    return input;
  }
}
